<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div v-if="!loading">
      <section
        class="section"
        style="
          position: relative;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
        "
        :style="{ backgroundImage: bannerImage }"
      >
        <div
          style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(
              to right,
              white,
              rgba(255, 255, 255, 0.2)
            );
          "
        ></div>
        <div
          class="has-padding-top-60"
          style="max-width: 700px; position: relative; z-index: 2"
        >
          <div class="columns">
            <div class="column has-text-centered-mobile is-3-desktop">
              <img :src="thumbnail(titleImage)" />
            </div>
            <div class="column is-9-desktop">
              <h1 class="title">
                {{ item.title }}
                {{
                  item.media_type === 'series' &&
                  item.mediadata &&
                  item.mediadata.seriesNo
                    ? `S${item.mediadata.seriesNo}`
                    : ''
                }}
              </h1>
              <p class="has-margin-bottom-15">
                <span
                  v-if="item.media_type"
                  class="has-text-weight-bold has-padding-5 has-margin-right-15"
                  >{{ item.media_type | capitalize }}</span
                >
                <span
                  v-if="year"
                  class="has-text-weight-bold has-padding-5 has-margin-right-15"
                  >{{ year }}</span
                >
                <span
                  v-if="mediaLength"
                  class="has-text-weight-bold has-padding-5 has-margin-right-15"
                  >{{ mediaLength }}</span
                >
                <span
                  v-if="ageRestriction"
                  class="has-padding-5 has-margin-right-15"
                  style="border: 1px solid #999"
                  >{{ ageRestriction }}</span
                >
                <span class="has-text-weight-bold has-padding-5"></span>
              </p>
              <p class="has-margin-bottom-15">{{ item.description }}</p>
            </div>
          </div>
          <template v-for="meta in metaToDisplay">
            <p
              v-if="item[meta.type] && item[meta.type].length > 0"
              :key="meta.type"
              class="has-margin-bottom-15"
            >
              <strong class="has-margin-right-10">{{ meta.label }}:</strong>
              <router-link
                v-for="metaItem in item[meta.type]"
                :key="metaItem.id"
                :to="{
                  name: 'Metadata',
                  params: { type: metaItem.type, id: metaItem.id }
                }"
                class="has-margin-right-5"
              >
                <b-tag type="is-primary">{{ metaItem.value }}</b-tag>
              </router-link>
            </p>
          </template>
          <div class="has-margin-top-30">
            <b-button
              v-if="item.mediadata && item.mediadata.trailerVideo"
              type="is-primary"
              icon-left="play-circle-outline"
              class="has-margin-right-10"
              @click="watchTrailer()"
            >
              Trailer
            </b-button>
            <b-button
              v-if="item.mediadata && item.mediadata.screenerVideo"
              type="is-primary"
              icon-left="play-circle-outline"
              class="has-margin-right-10"
              @click="watchScreener()"
            >
              Screener
            </b-button>
            <b-button icon-left="plus-circle-outline" @click="addToCart()">
              Add to List
            </b-button>
          </div>
        </div>
      </section>
      <section
        v-if="item.media_type === 'series' && episodes.length > 0"
        class="section"
      >
        <h2 class="title has-margin-top-15">{{ episodes.length }} Episodes</h2>
        <b-table
          :data="episodes"
          :narrowed="true"
          :loading="loading"
          :focusable="false"
          :mobile-cards="false"
        >
          <template slot-scope="props">
            <b-table-column field="id" label="Episode">
              <strong
                ><span v-if="props.row.title && props.row.title !== ''"
                  >{{ props.row.episode_number }}. {{ props.row.title }}</span
                >
                <span v-else
                  >Episode {{ props.row.episode_number }}</span
                ></strong
              >
              <span
                v-if="
                  props.row.episodedata &&
                    props.row.episodedata.releaseDate &&
                    props.row.episodedata.releaseDate !== ''
                "
              >
                - {{ props.row.episodedata.releaseDate | releaseDate }}</span
              >
            </b-table-column>

            <b-table-column field="description" label="Synopsis">
              {{ props.row.description }}
            </b-table-column>

            <b-table-column field="duration" label="Duration" centered>
              {{ props.row.episodedata.episodeLength }} mins
            </b-table-column>
          </template>
        </b-table>
      </section>
      <section v-if="similar && similar.length > 0" class="section">
        <h2 class="title has-margin-top-15">You might also like</h2>
        <CategorySlider :items="similar"></CategorySlider>
      </section>
    </div>
    <LoggedInModal
      :show="showLoggedInModal"
      :redirect-url="$route.path"
      @close-modal="showLoggedInModal = false"
      @login-redirect="showLoggedInModal = false"
    ></LoggedInModal>
    <VideoModal
      :show="showModal"
      :video-id="videoId"
      @close-modal="showModal = false"
    ></VideoModal>
    <AddToCartModal
      v-if="showAddToCartModal"
      :item="item"
      :show="showAddToCartModal"
      @close-modal="showAddToCartModal = false"
    ></AddToCartModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CategorySlider from '@/components/CategorySlider'
import VideoModal from '@/components/VideoModal'
import AddToCartModal from '@/components/AddToCartModal'
import LoggedInModal from '@/components/LoggedInModal'
import MediaApi from '@/api/media'
import EpisodeApi from '@/api/episodes'
import Filters from '@/mixins/filters'
import Utils from '@/mixins/utils'
import format from 'date-fns/format'

export default {
  name: 'MediaDetail',
  components: {
    CategorySlider,
    VideoModal,
    AddToCartModal,
    LoggedInModal
  },
  metaInfo() {
    const title = this.item && this.item.title ? this.item.title : ''
    const description =
      this.item && this.item.description ? this.item.description : ''
    return {
      title: title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: description
        }
      ]
    }
  },
  filters: {
    releaseDate(value) {
      return format(new Date(value), 'dd MMMM yyyy')
    }
  },
  mixins: [Filters, Utils],
  computed: {
    ...mapGetters(['isAuthenticated']),
    year() {
      if (
        this.item.mediadata &&
        this.item.mediadata.releaseDate &&
        this.item.mediadata.releaseDate !== ''
      ) {
        return new Date(this.item.mediadata.releaseDate).getFullYear()
      }
      return null
    },
    ageRestriction() {
      if (
        this.item.mediadata &&
        this.item.mediadata.ageRestriction &&
        this.item.mediadata.ageRestriction !== ''
      ) {
        return this.item.mediadata.ageRestriction
      }
      return null
    },
    bannerImage() {
      if (
        this.item.mediadata &&
        this.item.mediadata.bannerImage &&
        this.item.mediadata.bannerImage !== ''
      ) {
        return `url('${this.fullwidth(this.item.mediadata.bannerImage)}')`
      }
      return null
    },
    titleImage() {
      if (
        this.item.mediadata &&
        this.item.mediadata.titleImage &&
        this.item.mediadata.titleImage !== ''
      ) {
        return this.item.mediadata.titleImage
      }
      return null
    },
    mediaLength() {
      if (
        this.item.media_type === 'movies' &&
        this.item.mediadata &&
        this.item.mediadata.mediaLength
      ) {
        return `${this.item.mediadata.mediaLength} mins`
      } else if (
        this.item.media_type === 'series' &&
        this.item.mediadata &&
        this.item.mediadata.noOfEpisodes
      ) {
        return `${this.item.mediadata.noOfEpisodes} episodes`
      }
      return null
    }
  },
  watch: {
    $route() {
      this.fetchData()
    }
  },
  data() {
    return {
      loading: true,
      item: {},
      showModal: false,
      showAddToCartModal: false,
      showLoggedInModal: false,
      videoId: '',
      episodes: [],
      similar: [],
      metaToDisplay: [
        { type: 'actor', label: 'Cast' },
        { type: 'type', label: 'Content Types' },
        { type: 'genre', label: 'Genres' },
        { type: 'language', label: 'Languages' },
        { type: 'right', label: 'Rights' },
        { type: 'distribution', label: 'Distribution Rights' },
        { type: 'country', label: 'Country Rights' },
        { type: 'excludedcountry', label: 'Excluded Countries' },
        { type: 'tag', label: 'Tags' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.similar = []
      this.episodes = []
      let response = await MediaApi.getById(this.$route.params.id)
      this.item = response
      if (this.item.media_type === 'series') {
        this.episodes = await EpisodeApi.getAllByMediaId(this.item.id)
        this.episodes.forEach(
          item => (item.episodedata = JSON.parse(item.episodedata))
        )
      }
      this.item.mediadata = JSON.parse(this.item.mediadata)
      if (this.item.mediaMetadata.length > 0) {
        this.metaToDisplay.forEach(meta => {
          this.item[meta.type] = this.getMetadata(
            this.item.mediaMetadata,
            meta.type
          )
        })
        MediaApi.getByGenres(
          this.item.genre.map(item => item.id),
          this.item.id,
          10
        ).then(response => {
          if (response && response.length > 0) {
            response.forEach(item => {
              item.mediadata = JSON.parse(item.mediadata)
            })
          }
          this.similar = response
        })
      }
      this.loading = false
    },
    getMetadata(metadata, type) {
      return metadata
        .filter(item => item.metadata_type === type)
        .map(item => ({
          id: item.metadata_id,
          type: item.metadata_type,
          value: item.value
        }))
    },
    watchTrailer() {
      this.videoId = this.item.mediadata.trailerVideo
      this.showModal = true
    },
    watchScreener() {
      this.videoId = this.item.mediadata.screenerVideo
      this.showModal = true
    },
    addToCart() {
      if (this.isAuthenticated) {
        this.showAddToCartModal = true
      } else {
        this.showLoggedInModal = true
      }
    }
  }
}
</script>
